import PropTypes from 'prop-types';
import connect from 'react-redux/es/connect/connect';
import React, { PureComponent } from 'react';
import Button from 'react-bootstrap/es/Button';
import Form from 'react-bootstrap/es/Form';
import FormGroup from 'react-bootstrap/es/FormGroup';
import FormControl from 'react-bootstrap/es/FormControl';
import { closeModal } from 'redux/modules/modal';
import './joinGroupModal.css';

class SelectGroupModal extends PureComponent {
    static propTypes = {
        dispatch: PropTypes.func.isRequired,
        // for switching of group
        profileData: PropTypes.object,
        handleSwitchUser: PropTypes.func,
        // for send reminder
        survey: PropTypes.array,
        handleSendReminder: PropTypes.func
    }

    state = {
        currentSelection: this.props.profileData ? this.props.profileData.current_group : this.props.survey[0].id
    }

    onCurrentSelectionChange = (e) => {
        this.setState({
            currentSelection: parseInt(e.target.value, 10) || e.target.value
        });
    }

    handleSumbit = (e) => {
        e.preventDefault();

        this.onCancel();

        if (this.props.profileData) {
            this.props.handleSwitchUser(1, this.state.currentSelection);
        }
        else {
            this.props.handleSendReminder(this.state.currentSelection);
        }
    }

    onCancel = () => {
        this.props.dispatch(closeModal());
    }

    render() {
        const arr = this.props.profileData ? this.props.profileData.groups : this.props.survey;

        return (
            <div className='joingroup-modal'>
                <div className='form-container'>
                    <Form onSubmit={this.handleSumbit}>
                        <FormGroup controlId='group-selection'>
                            <FormControl componentClass='select' value={this.state.currentSelection} onChange={this.onCurrentSelectionChange}>
                                {arr.map((item, index) =>
                                    <option value={item.id} key={index}>{item.name || item.title}</option>
                                )}
                            </FormControl>
                        </FormGroup>
                        <div className='button-footer-center'>
                            <Button
                                className='btn--red'
                                onClick={this.onCancel}>
                                {'Cancel'}
                            </Button>
                            <Button
                                className='btn--blue'
                                type='submit'>
                                Submit
                            </Button>
                        </div>
                    </Form>
                </div>
            </div>
        );
    }

}

export default connect()(SelectGroupModal);



// WEBPACK FOOTER //
// ./src/components/Group/SelectGroupModal.js